<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-01 15:58:29
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="card rules-card">
    <div class="card-header">
      <div>规章制度</div>
      <div class="more" v-if="showMoreBtn" @click="handleMoreClick">更多</div>
    </div>
    <Tabs :animated="false" @on-click="handleTabChange">
        <TabPane label="规章制度" name="1">
          <div class="tab-content">
            <div v-if="errorCode === '10044'" class="error-message">
              {{ errorMessage }}
            </div>
            <div v-else class="info-list">
              <div class="info" v-for="(item,index) in activeRulesList" :key="index" @click="handleItemClick(item)" @mouseenter="handleItemHover(item, $event)" @mouseleave="handleItemLeave($event)">
                <div :class="index==0?'tips-top':''">{{ item.title || item.subject || item.docsubject?.name || item.name }}</div>
                <div>{{ item.doclastmoddate || item.createTime || item.publishTime || item.date }}</div>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="已作废制度" name="2">
          <div class="tab-content">
            <div v-if="errorCode === '10044'" class="error-message">
              {{ errorMessage }}
            </div>
            <div v-else class="info-list">
              <div class="info" v-for="(item,index) in activeRulesList" :key="index" @click="handleItemClick(item)" @mouseenter="handleItemHover(item, $event)" @mouseleave="handleItemLeave($event)">
                <div :class="index==0?'tips-top':''">{{ item.title || item.subject || item.docsubject?.name || item.name }}</div>
                <div>{{ item.doclastmoddate || item.createTime || item.publishTime || item.date }}</div>
              </div>
            </div>
          </div>
        </TabPane>
    </Tabs>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      activeTab: '1', // 当前选中的标签页，1-正常规章制度，2-已作废制度
      rulesList1: [], // 正常规章制度列表
      rulesList2: [], // 已作废制度列表
      errorCode: null, // 错误码
      errorMessage: '' // 错误信息
    }
  },
  computed: {
    // 根据当前选中的标签页返回对应的列表
    activeRulesList () {
      return this.activeTab === '1' ? this.rulesList1 : this.rulesList2
    },
    // 更多按钮是否显示：有数据且第一条有 moreUrl
    showMoreBtn () {
      const list = this.activeRulesList
      if (!list || list.length === 0) return false
      const first = list[0]
      return first && first.docsubject && first.docsubject.moreUrl
    }
  },
  created () {
    // 初始化加载正常规章制度
    this.getRulesList('1')
  },
  methods: {
    // 更多点击：先通过第一条数据的 link 存储 token，再跳转 moreUrl（因对方禁止 iframe，改用新窗口）
    handleMoreClick () {
      const firstItem = this.activeRulesList[0]
      const listUrl = firstItem?.docsubject?.moreUrl
      if (!listUrl) return

      const doNavigate = (targetUrl) => {
        if (this.isMobile()) {
          window.location.href = targetUrl
        } else {
          window.open(targetUrl, '_blank')
        }
      }

      const link = firstItem?.docsubject && (this.isMobile() ? firstItem.docsubject.mobilelink : firstItem.docsubject.link)
      if (link) {
        this.$request.get(`/sso/oa/user/mapping/ssoLogin/getToken`).then(res => {
          const { code, data } = res.data
          if (code === 'OK') {
            const tokenUrl = `${link}&ssoToken=${data}`
            const win = window.open(tokenUrl, 'rulesMore')
            if (win) {
              setTimeout(() => {
                if (!win.closed) {
                  win.location.href = listUrl
                } else {
                  doNavigate(listUrl)
                }
              }, 100)
            } else {
              doNavigate(listUrl)
            }
          } else {
            doNavigate(listUrl)
          }
        }).catch(() => {
          doNavigate(listUrl)
        })
      } else {
        doNavigate(listUrl)
      }
    },
    // 标签页切换事件
    handleTabChange (name) {
      this.activeTab = name
      // 如果对应列表为空，则加载数据
      if (name === '1' && this.rulesList1.length === 0) {
        this.getRulesList('1')
      } else if (name === '2' && this.rulesList2.length === 0) {
        this.getRulesList('2')
      }
    },
    // 获取规章制度列表
    getRulesList (type) {
      this.$request.post(`/sso/workItem/findRules/${type}`).then(res => {
        const { code, data, message } = res.data
        // 处理错误码 10044
        if (code === '10044') {
          this.errorCode = code
          this.errorMessage = message || '暂无数据'
          // 清空列表
          if (type === '1') {
            this.rulesList1 = []
          } else if (type === '2') {
            this.rulesList2 = []
          }
          return
        }

        if (code === 'OK') {
          this.errorCode = null
          this.errorMessage = ''
          // 根据实际返回的数据结构调整
          const list = data?.list || data?.records || (Array.isArray(data) ? data : []) || []
          // 限制显示数量为7条
          const limitedList = list.length > 7 ? list.slice(0, 7) : list

          if (type === '1') {
            this.rulesList1 = limitedList
          } else if (type === '2') {
            this.rulesList2 = limitedList
          }
        }
      }).catch(err => {
        console.error(`获取${type === '1' ? '正常' : '已作废'}规章制度列表失败:`, err)
        this.errorCode = 'error'
        this.errorMessage = '加载失败，请稍后重试'
        if (type === '1') {
          this.rulesList1 = []
        } else {
          this.rulesList2 = []
        }
      })
    },
    // 判断是否为移动端
    isMobile () {
      const ua = navigator.userAgent.toLowerCase()
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
      return mobileRegex.test(ua) || window.innerWidth <= 768
    },
    // 点击事件处理
    handleItemClick (item) {
      if (!item.docsubject) {
        return
      }
      this.$request.get(`/sso/oa/user/mapping/ssoLogin/getToken`).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          const link = this.isMobile() ? item.docsubject.mobilelink : item.docsubject.link
          if (link) {
            if (this.isMobile()) {
              // 移动端：当前窗口打开
              window.location.href = `${link}&ssoToken=${data}`
            } else {
              // PC端：新窗口打开
              window.open(`${link}&ssoToken=${data}`, '_blank')
            }
          }
          console.log(data)
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // hover 事件处理
    handleItemHover (item, event) {
      // 可以在这里添加 hover 时的逻辑，比如显示提示信息等
      event.currentTarget.style.cursor = 'pointer'
    },
    // 鼠标离开事件处理
    handleItemLeave (event) {
      // 恢复默认样式
      event.currentTarget.style.cursor = 'default'
    }
  }
}
</script>

<style scoped lang="less">
@import url("../index.modules.less");

.rules-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/deep/ .ivu-tabs {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/deep/ .ivu-tabs-bar {
  flex-shrink: 0;
}

/deep/ .ivu-tabs-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

/deep/ .ivu-tabs-tabpane {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card {
  position: relative;

  .more {
    cursor: pointer;
  }

  .tab-content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
  }

  .info-list {
    width: 100%;
  }

  .info {
    font-size: 17px;
    line-height: 1.45;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #f5f5f5;
      border-radius: 4px;
    }

    > div:first-child {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0; // 确保 flex 子元素可以收缩
      margin-right: 12px;
    }

    > div:last-child {
      flex-shrink: 0; // 日期部分不收缩
      white-space: nowrap;
    }
  }

  .error-message {
    color: #999;
    font-size: 17px;
    text-align: center;
    padding: 20px;
  }
}
</style>
